/**
 * Games **session** sub-router — the full-screen, guest-capable routes that run
 * an actual game: create → host (TV/laptop display), and player (phone) views.
 * Mounted at `/games/*` behind `GameAuthGate`, so a friend who follows a room
 * link is signed in anonymously and lands straight in the game.
 *
 * The games **menu** (the picker at `/games`) is NOT here — it's `HubHomePage`,
 * which stays inside the platform `AppShell` (nav + real-account auth). Keeping
 * the two separate is deliberate: browsing/launching games is part of the app;
 * a live session is a standalone, shareable, phone-friendly surface.
 *
 * Inner routes (paths relative to `/games`):
 *   'create/:gameId'            -> CreateRoomPage  (creates room, redirects to host)
 *   ':gameId/host/:code'        -> HostShell       (lobby + host game view)
 *   ':gameId/play/:code/new'    -> JoinRedirect    (mints/loads per-device uid)
 *   ':gameId/play/:code/:uid'   -> PlayerShell     (lobby + player game view)
 *   'test' / 'camel-up-test'    -> dev harnesses   (dev builds only)
 *   '*'                         -> NotFoundPage
 */

import { Route, Routes } from 'react-router-dom';
import { CreateRoomPage } from './routing/CreateRoomPage';
import { HostShell } from './routing/HostShell';
import { JoinRedirect } from './routing/JoinRedirect';
import { NotFoundPage } from './routing/NotFoundPage';
import { PlayerShell } from './routing/PlayerShell';
import { DevHarnessPage } from './scotland-yard/DevHarnessPage';
import { DevHarnessPage as CamelUpDevHarnessPage } from './camel-up/DevHarnessPage';

export function GamesPage() {
  return (
    <Routes>
      { /* Visual dev harnesses — only mounted in dev, never on the live site. */ }
      { import.meta.env.DEV && (
        <Route path="test" element={<DevHarnessPage />} />
      ) }
      { import.meta.env.DEV && (
        <Route path="camel-up-test" element={<CamelUpDevHarnessPage />} />
      ) }
      <Route path="create/:gameId" element={<CreateRoomPage />} />
      <Route path=":gameId/host/:code" element={<HostShell />} />
      <Route path=":gameId/play/:code/new" element={<JoinRedirect />} />
      <Route path=":gameId/play/:code/:uid" element={<PlayerShell />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
